import { pipes } from "@easyops-cn/brick-next-pipes";
export { pipes, utils } from "@easyops-cn/brick-next-pipes";
const PipeRegistry = new Map(Array.from(Object.entries(pipes)));

/** For next-core internal usage only. */
export function processPipes(value, pipes) {
  if (pipes.length === 0) {
    return value;
  }
  let result = value;
  for (const pipe of pipes) {
    const registeredPipe = PipeRegistry.get(pipe.identifier);
    if (!registeredPipe) {
      // eslint-disable-next-line no-console
      console.warn(`Unknown pipe: ${pipe.identifier}`);
      return;
    }
    result = registeredPipe(result, ...pipe.parameters);
  }
  return result;
}
//# sourceMappingURL=index.js.map